<template>
  <div class="card" v-loading="cardLoading">
    <div class="card-content" v-if="!isCardDisabled">
      <CardList />
      <AddCard @update="updateList" />
    </div>
    <!-- 现金支付 -->
    <Cash />
    <div class="card-content" v-if="isCardDisabled">
      <CardList />
      <AddCard @update="updateList" />
    </div>
    <!-- didicash支付 -->
    <!-- <DidiCash /> -->
    <!-- paypay -->
    <!-- <PayPay /> -->
    <!-- pos支付 -->
    <!-- <Pos /> -->
  </div>
</template>

<script>
import CardList from './cardList.vue';
import AddCard from './addCard.vue';
import Cash from './cash.vue';
// import PayPay from './paypay.vue';
// import DidiCash from './didicash.vue';
import { mapState } from 'vuex';
// import { PAY_CHANNEL_TYPE } from '@/const/paymentProcess';

// import Pos from './pos.vue';
export default {
  name: 'CardContent',
  components: {
    CardList,
    AddCard,
    Cash,
    // DidiCash,
    // PayPay,
    // Pos,
  },
  data() {
    return {
      selectedMent: {},
    };
  },
  computed: {
    ...mapState({
      cardLoading: ({ pay }) => pay.cardLoading,
      paymentsExtraInfo: ({ pay }) => pay.paymentsExtraInfo,
    }),
    isCardDisabled() {
      return Number(this.paymentsExtraInfo?.isDisplay) === 0;
    },
  },
  methods: {
    updateList() {
      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 504px;
  overflow: auto;
  padding-top: 10px;
  .card-content {
    width: 422px;
    padding-left: 20px;
    background: #fff;
    border-radius: 8px;
    margin: 0 auto 20px auto;
  }
}
@media screen and (max-width: 768px) {
  .card {
    height: 70vh;
    .card-content {
      width: rem(702);
      padding-left: rem(20);
      border-radius: rem(12);
    }
  }
}
</style>
